/* eslint-disable jsx-a11y/anchor-is-valid */
import { MoreDropDown } from "../../../common";
import { useGRExtra } from "./useGRExtra";

export const GRExtra = ({ GRDetails = {}, btnStyles = {} }) => {
  const { handleDownloadGR } = useGRExtra({});

  return (
    <>
      <MoreDropDown btnStyles={btnStyles}>
        <a
          className="cursor-pointer"
          onClick={() => handleDownloadGR(GRDetails)}
        >
          Download GRN
        </a>
      </MoreDropDown>
    </>
  );
};
